import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CenterFlexBox from "components/CenterFlexBox";
import CircleProgressbar from "components/Report/CircleProgressbar";
import Title from "../Title";

export default function AllSectionScores({ active, scores }) {

    return (
        (active) ? (
            <Box>
                <Title title={'Section-wise Indicative Band Score (out of 9)'} />
                <Box mb={2}>
                    <Box display='flex' gap={4} my={4}>
                        {
                            scores ? Object.keys(scores).map((key, index) => (
                                (key !== 'overall') &&
                                <Box
                                    display="flex"
                                    flexDirection="column"
                                    alignItems="center"
                                    fontSize="12px"
                                    key={index}
                                >
                                    <CenterFlexBox
                                        mb={2} backgroundColor='#D7E5FF'
                                        px={2} py={0.5} borderRadius={1}
                                        color='#235598'
                                    >
                                        <Typography variant="body01-bold">
                                            {key.charAt(0).toUpperCase() + key.substring(1)}
                                        </Typography>
                                    </CenterFlexBox>
                                    {
                                        (scores?.[key]?.score >= 0) &&
                                        <CircleProgressbar
                                            value={scores?.[key]?.score}
                                            size={90}
                                            percent={false}
                                            color={'#02569D'}
                                        />
                                    }
                                </Box>

                            )) : <Typography variant="body01-bold">
                                NA
                            </Typography>
                        }
                    </Box>
                </Box>
            </Box>
        ) : null
    );
}